const BASE = process.env.REACT_APP_API_BASE_URL || "https://l8trgm1cje.execute-api.us-east-1.amazonaws.com/dev";

const API = {
  // existing
  triggerCall: `${BASE}/trigger`,
  chat:        `${BASE}/chat`,
  translate:   `${BASE}/translate`,
  // SaaS auth
  register:         `${BASE}/auth/register`,
  verifyOtp:        `${BASE}/auth/verify-otp`,
  validateSession:  `${BASE}/auth/validate-session`,
  // Knowledge base
  kbTrain:   `${BASE}/kb/train`,
  kbList:    `${BASE}/kb/list`,
  kbDelete:  `${BASE}/kb/delete`,
  // SME profile
  smeProfile: `${BASE}/sme/profile`,
  // Admin
  adminStats:              `${BASE}/admin/stats`,
  adminUpdateSubscription: `${BASE}/admin/update-subscription`,
  // Call Logs
  callLogsList:    `${BASE}/call-logs/list`,
  callLogsInsights: `${BASE}/call-logs/insights`,
};

export default API;
